(() => {
  const KEY = 'oe_newsletter_popup_v1';
  const DAY = 24 * 60 * 60 * 1000;

  const init = () => {
    const popup = document.querySelector('[data-oe-newsletter-popup]');
    if (!popup) return;

    const form = popup.querySelector('form');
    const success = popup.querySelector('[data-oe-newsletter-success]');
    const closeButtons = [...popup.querySelectorAll('[data-oe-newsletter-close]')];
    const firstField = popup.querySelector('input, button');
    let retries = 0;
    let opened = false;

    const readState = () => {
      try { return JSON.parse(localStorage.getItem(KEY) || '{}'); }
      catch (_) { return {}; }
    };

    const remember = (days, reason) => {
      try {
        localStorage.setItem(KEY, JSON.stringify({ until: Date.now() + (days * DAY), reason }));
      } catch (_) {}
    };

    const privacyBannerVisible = () => {
      const banner = document.querySelector('#shopify-pc__banner');
      if (!banner || banner.hidden) return false;
      const style = window.getComputedStyle(banner);
      const rect = banner.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0 && rect.width > 0;
    };

    const open = () => {
      if (opened) return;
      opened = true;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('oe-newsletter-open');
      requestAnimationFrame(() => popup.classList.add('is-open'));
      setTimeout(() => firstField?.focus({ preventScroll: true }), 240);
    };

    const close = (persist = true) => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('oe-newsletter-open');
      if (persist) remember(14, 'dismissed');
      setTimeout(() => { popup.hidden = true; }, 230);
    };

    const attemptOpen = () => {
      if (opened) return;
      if (privacyBannerVisible() && retries < 8) {
        retries += 1;
        setTimeout(attemptOpen, 3200);
        return;
      }
      open();
    };

    closeButtons.forEach((button) => button.addEventListener('click', () => close(true)));
    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close(true);
    });

    if (form) {
      form.addEventListener('submit', () => remember(180, 'subscribed'));
    }

    if (success) {
      remember(180, 'subscribed');
      open();
      setTimeout(() => close(false), 4200);
      return;
    }

    const state = readState();
    if (state.until && Number(state.until) > Date.now()) return;

    const delay = window.innerWidth < 750 ? 11000 : 14000;
    const timer = setTimeout(attemptOpen, delay);

    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      if ((window.scrollY / max) >= 0.38) {
        window.removeEventListener('scroll', onScroll);
        clearTimeout(timer);
        attemptOpen();
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
